/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";

type TimeSlot = {
  value: string;
  label: string;
};

export interface SchedulingStepProps {
  orderType: "delivery" | "takeaway";
  timeSlots: TimeSlot[];
  selectedTime: string;
  onSelectTime: (value: string) => void;
  orderNotes: string;
  onUpdateNotes: (value: string) => void;
}

export const SchedulingStep = defineComponent<SchedulingStepProps>({
  name: "SchedulingStep",
  props: [
    "orderType",
    "timeSlots",
    "selectedTime",
    "onSelectTime",
    "orderNotes",
    "onUpdateNotes",
  ],
  setup(props) {
    const { t } = useLocalization();
    return () => (
      <div class="card bg-base-100/50 shadow-lg border border-base-300">
        <div class="card-body space-y-6">
          <div class="flex gap-3 justify-start items-center">
            <h3 class="text-lg font-semibold mt-0 text-accent">
              {t("pos.phonein.scheduling_notes")}
            </h3>
          </div>

          <div class="grid gap-4 lg:grid-cols-1">
            <label class="form-control hidden">
              <span class="label-text font-medium">
                {props.orderType === "delivery"
                  ? t("pos.phonein.delivery_time")
                  : t("pos.phonein.pickup_time")}
              </span>
              <select
                class="select select-bordered"
                value={props.selectedTime}
                onChange={(event) =>
                  props.onSelectTime((event.target as HTMLSelectElement).value)
                }
              >
                {props.timeSlots.map((slot) => (
                  <option key={slot.value} value={slot.value}>
                    {slot.label}
                  </option>
                ))}
              </select>
            </label>
            <label class="form-control">
              <span class="label-text font-medium">
                {t("pos.phonein.order_notes")}
              </span>
              <textarea
                class="textarea textarea-bordered"
                rows={3}
                placeholder={t("pos.phonein.notes_placeholder")}
                value={props.orderNotes}
                onInput={(event) =>
                  props.onUpdateNotes(
                    (event.target as HTMLTextAreaElement).value,
                  )
                }
              />
            </label>
          </div>
        </div>
      </div>
    );
  },
});
